import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, takeUntil, throwError } from 'rxjs';
import { config } from '../../../environments/environment';
import { MaintenanceService } from '../services/maintenance.service';
import { RECOVERY_GENERATION } from './recovery-context';

export const maintenanceInterceptor: HttpInterceptorFn = (request, next) => {
  // The native app has no backend before a space was added.
  if (!config.backendUrl) return next(request);
  const url = new URL(request.url, location.href);
  if (
    url.origin !== new URL(config.backendUrl).origin ||
    !url.pathname.startsWith('/v1/') ||
    url.pathname === '/v1/maintenance'
  )
    return next(request);
  const maintenance = inject(MaintenanceService);
  const revision = maintenance.revision;
  if (
    maintenance.active() &&
    !maintenance.isRecoveryCurrent(request.context.get(RECOVERY_GENERATION))
  )
    return throwError(() => new HttpErrorResponse({ status: 503, error: { code: 'MAINTENANCE' } }));
  return next(request).pipe(
    takeUntil(maintenance.entered),
    catchError((error) => {
      if (
        error instanceof HttpErrorResponse &&
        error.status === 503 &&
        error.error?.code === 'MAINTENANCE'
      ) {
        if (revision === maintenance.revision) {
          if (!maintenance.accept(error.error)) maintenance.markUnavailable(revision);
          void maintenance.check();
        }
      }
      return throwError(() => error);
    })
  );
};
